module.exports = __webpack_public_path__ + "img/writer-travel-1.6a619363.png";